export const CARD_ON_FILE_HASH = '#card-on-file';
